module.exports = __webpack_public_path__ + "static/media/orc-female.0e127f1b.png";